export default "__VITE_ASSET__8902a0b3__"